import * as ErrorMessages from '../constants/ErrorMessages';

const emailRegex =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Check if a field has a value that can be tested
 * @param  {string}   value   Value of field
 * @return {boolean}          If the field has a value
 */
function hasValue(value) {
  return (
    typeof value !== 'undefined' && value !== null && value !== '' && value
  );
}

const messages = {
  required: ErrorMessages.ERROR_REQUIRED,
  email: ErrorMessages.ERROR_EMAIL,
  number: ErrorMessages.ERROR_NUMBER,
  file: ErrorMessages.ERROR_FILE,
  option: ErrorMessages.ERROR_OPTION,
};

export const validators = {
  message: (name: string, fieldType: string): string => {
    const requiredMessage = `${name} ${messages['required']}`;

    if (!fieldType || fieldType === 'required') {
      return requiredMessage;
    }

    return '';
  },
  required: (value: any): boolean => {
    // Check if value is a string
    const valueString = typeof value === 'string' ? value : String(value);
    const trimmed = (valueString || '').trim();

    return hasValue(trimmed);
  },
  email: (value: string): boolean => {
    return emailRegex.test(value);
  },
  number: (value: string): boolean => {
    if (hasValue(value)) {
      return /^[0-9()+ ]+$/.test(value);
    }
  },
  file: (value: string): boolean => {
    return false; // hasValue(value) && hasValue(match) && match === value;
  },
  bank: (value: string): boolean => {
    return hasValue(value);
  },
  option: (value: string): boolean => {
    return hasValue(value);
  },
};
